import _                                                 from 'underscore';
import React, { FC }                                     from 'react';
import { SystemAccountingQueries }                       from '../../../queries';
import { ItemFromQuery }                                 from './ItemFromQuery';
import { PROJECT_MILESTONE_INFO, ProjectMilestoneField } from '../../../constants/ProductEnums';
import { ProjectService }                                from '../../../services';
import { AsTagProp, CorvalProject, Uuid }                from '../../../types';
import { useProjectTermDictionary }                      from '../../../hooks';
import { ProjectQueries }                                from '../../../queries/ProjectQueries';
import { InlineLoadingIndicatorLabel }                   from '../util/loading/InlineLoadingIndicatorLabel';


interface ProjectDetailsProps {
    id: Uuid,
    as?: AsTagProp,
    get?: string,
    attribute?: keyof CorvalProject,
    fallback?: any

    [ additionalProps: string ]: any
}

const ProjectDetailsDefaultProps: ProjectDetailsProps = {
    id:        null,
    as:        React.Fragment,
    get:       'id',
    attribute: 'name',
    fallback:  '[Project Detail]'
}

const ProjectDetails: FC<ProjectDetailsProps> = ( props ) => {

    if( !props.id ) return props.fallback;

    let { get, id, as, loadingComponent, fallback, children, attribute, } = props;

    return (

        <ItemFromQuery
            query={ SystemAccountingQueries.queries.GET_PROJECT( get ) }
            queryOptions={ { variables: { id: id } } }
            queryResultObject={ data => _.first( data.projects ) }
            as={ as }
            loadingComponent={ loadingComponent ?? null }
            noItemComponent={ () => fallback }>

            { ( project: CorvalProject ) => _.isFunction( children )
                                            ? children( project )
                                            : project[ attribute ] }

        </ItemFromQuery>
    );
};

ProjectDetails.defaultProps = ProjectDetailsDefaultProps;

/*------------------------------------------------------------------------------------------------------------------------------------------------------*/

interface ProjectMilestoneDateProps {
    id: Uuid,
    projectVersionId?: Uuid,
    milestone: Uuid | ProjectMilestoneField,

    [ additionalProps: string ]: any
}

const ProjectMilestoneDateDefaultProps: ProjectMilestoneDateProps = {
    id:               null,
    projectVersionId: null,
    milestone:        null,
}

const ProjectMilestoneDate: FC<ProjectMilestoneDateProps> = ( props ) => {

    let { id, projectVersionId, milestone } = props,
        { termDictionary }                  = useProjectTermDictionary();

    if( !_.isString( milestone ) ) return null;

    let field = PROJECT_MILESTONE_INFO[ milestone ]
                ? PROJECT_MILESTONE_INFO[ milestone ].PROJECT_FIELD
                : milestone;

    return (
        <ProjectDetails id={ id } get={ `id ${ ProjectQueries.fragments.PROJECTS.TIMELINE_FIELDS_AND_DEFINED_TIMINGS( projectVersionId ) }` } loadingComponent={ <InlineLoadingIndicatorLabel/> }>
            { ( project: CorvalProject ) => {

                let timelineFields = ProjectService.getTimelineDataObjectFromProjectFields( project, termDictionary ),
                    timelineField  = _.findWhere( timelineFields, { fieldId: field } ) ?? null;

                return timelineField ? _.isFunction( props.children ) ? props.children( timelineField ) : timelineField.value : null;

            } }
        </ProjectDetails>
    );
}

ProjectMilestoneDate.defaultProps = ProjectMilestoneDateDefaultProps;

export { ProjectDetails, ProjectMilestoneDate };
